import { render, staticRenderFns } from "./openLayout.vue?vue&type=template&id=6755f067&scoped=true&"
import script from "./openLayout.vue?vue&type=script&lang=js&"
export * from "./openLayout.vue?vue&type=script&lang=js&"
import style0 from "./openLayout.vue?vue&type=style&index=0&id=6755f067&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6755f067",
  null
  
)

export default component.exports